<div class="images-strip" aria-hidden="true">
  <div class="images-strip__image">
    <img src="images/taller-1.png" alt="" loading="lazy">
  </div>
  <div class="images-strip__image">
    <img src="images/taller-2.png" alt="" loading="lazy">
  </div>
  <div class="images-strip__image">
    <img src="images/taller-3.png" alt="" loading="lazy">
  </div>
</div>
